<template>
    <div class="scores-container">
    <div class="risk-score-card">
        <i class="fas fa-bell risk-icon"> Subscription Tracker</i> <button @click="currentTab = 'addSubscription'"><i class="fas fa-plus">Add</i></button></div>
      
      <div class="toolbar">
  
      </div><br>
  
        <table>
          <tr>
            <th>Name</th>
            <th>Payment Frequency</th>
            <th>Cost</th>
            <th>Currency</th>
            <th>Usage Frequency</th>
            <th>Actions</th>
          </tr>
          <tr v-for="subscription in subscriptions" :key="subscription.id">
            <td data-label="Name">{{ subscription.name }}</td>
            <td data-label="Frequency">{{ subscription.frequency }}</td>
            <td data-label="Cost">{{ subscription.cost }}</td>
            <td data-label="Currency">{{ subscription.currency }}</td>
            <td data-label="Usage">{{ subscription.usage_frequency }}</td>
            
            <td data-label="Actions">
              <button @click="editSubscription(subscription)">Edit</button>
              <button @click="deleteSubscription(subscription.id)">Delete</button>
              
            </td>
          </tr>
    
        </table>    
   
      </div>
  
      <!-- Add/Edit Subscription Form -->
      <div v-if="currentTab === 'addSubscription'">
        <form @submit.prevent="isEditing ? updateSubscription() : addSubscription()" class="subscription-form">
          <!-- Subscription Name -->
          <label>Name:  <select v-model="currentSubscription.name" required>
            <option disabled value="">Select a subscription</option>
            <option v-for="suggestion in subscriptionSuggestions" :key="suggestion" :value="suggestion">{{ suggestion }}</option>
            <option value="other">Other (Specify)</option>
          </select>
        </label>
          <!-- Custom Subscription Name Input -->
          <div v-if="currentSubscription.name === 'other'">
          <input type="text" v-model="currentSubscription.customName" placeholder="Enter subscription name" required />
        </div>
          <!-- Frequency -->
          <label>Frequency:
            <select v-model="currentSubscription.frequency" required>
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
              <option value="annually">Annually</option>
            </select>
          </label>
          <!-- Cost -->
          <label>Cost: 
  <input 
    type="number" 
    v-model="currentSubscription.cost" 
    @blur="formatCost" 
    step="0.01" 
    required />
</label>
          <!-- Currency -->
          <label>Currency:
            <select v-model="currentSubscription.currency" required>
              <option value="CAD">CAD</option>
              <option value="USD">USD</option>
            </select>
          </label>
          <!-- Usage Frequency -->
          <label>Usage Frequency:
            <select v-model="currentSubscription.usage_frequency" required>
              <option value="always">All the time</option>
              <option value="sometimes">Sometimes</option>
              <option value="rarely">Rarely</option>
              <option value="never">Never (I really should cancel this)</option>
            </select>
          </label>
          <button type="submit">{{ isEditing ? 'Update' : 'Add' }} Subscription</button>     
        </form>
      </div><br>
  </template>
  
  <script>
import axios from 'axios';
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      currentTab: 'list',
      subscriptions: [],
      subscriptionSuggestions: [
        'Netflix', 'Prime Video', 'Google Storage', 'Disney+', 'Apple Music', 'Hulu', 'Crave', 
        'Audible', 'The Globe and Mail', 'ClassPass', 'HelloFresh', 'Microsoft Office 365', 
        'Zoom', 'Adobe Creative Cloud', 'Google One', 'Fitness App'
      ],
      currentSubscription: {
        id: null,
        name: '',
        customName: '', // for 'other' option
        frequency: '',
        cost: 0,
        currency: 'CAD',
        usage_frequency: 'monthly'
      },
      isEditing: false,
      totalCost: 0
    };
  },
  async mounted() {
    await this.fetchSubscriptions();
  
  },
  methods: {
    async fetchSubscriptions() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const response = await axios.get('https://api.riskypaws.com/frontoffice/api/subscription/', {
          headers: { 'X-Cognito-Sub': user.attributes.sub }
        });
        this.subscriptions = response.data;
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
      }
    },
    prepareSubscriptionForSaving() {
      if (this.currentSubscription.name === 'other') {
        this.currentSubscription.name = this.currentSubscription.customName;
      }
    },
    async addSubscription() {
      this.prepareSubscriptionForSaving();
      try {
        const user = await Auth.currentAuthenticatedUser();
        await axios.post('https://api.riskypaws.com/frontoffice/api/subscription/', this.currentSubscription, {
          headers: { 'X-Cognito-Sub': user.attributes.sub }
        });
        await this.fetchSubscriptions();
      
        this.resetCurrentSubscription();
        this.currentTab = 'list';
      } catch (error) {
        console.error('Error adding subscription:', error);
      }
    },
    editSubscription(subscription) {
      this.currentSubscription = { ...subscription, customName: subscription.name };
      this.isEditing = true;
      this.currentTab = 'addSubscription';
    },
    async updateSubscription() {
      this.prepareSubscriptionForSaving();
      try {
        const user = await Auth.currentAuthenticatedUser();
        await axios.put(`https://api.riskypaws.com/frontoffice/api/subscription/${this.currentSubscription.id}/`, this.currentSubscription, {
          headers: { 'X-Cognito-Sub': user.attributes.sub }
        });
        await this.fetchSubscriptions();
        this.resetCurrentSubscription();
        this.currentTab = 'list';
      } catch (error) {
        console.error('Error updating subscription:', error);
      }
    },
    async deleteSubscription(id) {
      try {
        const user = await Auth.currentAuthenticatedUser();
        await axios.delete(`https://api.riskypaws.com/frontoffice/api/subscription/${id}/`, {
          headers: { 'X-Cognito-Sub': user.attributes.sub }
        });
        await this.fetchSubscriptions();
       
      } catch (error) {
        console.error('Error deleting subscription:', error);
      }
    },
 
    resetCurrentSubscription() {
      this.currentSubscription = {
        id: null,
        name: '',
        customName: '',
        frequency: '',
        cost: 0,
        currency: 'CAD',
        usage_frequency: ''
      };
      this.isEditing = false;
    },
    formatCost() {
      if (this.currentSubscription.cost !== '') {
        this.currentSubscription.cost = parseFloat(this.currentSubscription.cost).toFixed(2);
      }
    }
  }
};
</script>

<style scoped>

.scores-container {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: white;
  border: 2px solid #4A148C;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.risk-score-card {
  display: flex;
  align-items: center;
  justify-content: space-between; /* Aligns items to start and end */
  margin-bottom: 20px;
  background-color: #36454f;
  color: white;
  font-size: 24px;
  padding: 15px;
  border-radius: 10px;
}

/* Table Styles */
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

th, td {
  border: 1px solid #4A148C;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f4f4f4;
  color: #333;
}

/* Button Styles */
button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

button:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}

/* Form Styles */
.subscription-form label {
  display: block;
  margin: 10px 0;
}

.subscription-form input[type="text"],
.subscription-form input[type="number"],
.subscription-form select {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .scores-container table, 
  .scores-container thead, 
  .scores-container tbody, 
  .scores-container tr { 
    display: block; 
    width: 100%;
  }

  .scores-container th { 
    display: none; /* Hide table headers */
  }

  .scores-container td { 
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ddd;
  }

  .scores-container td:before { 
    content: attr(data-label);
    font-weight: bold;
    flex-basis: 40%;
  }

  .scores-container td[data-label="Actions"] button {
    flex-grow: 1;
  }
}

@media screen and (max-width: 600px) {
  .risk-score-card, .toolbar button, .event-form label, .event-form input, .event-form select, .event-form button {
    font-size: 14px; /* Adjust font size for better readability on mobile */
  }

  .button, .toolbar button {
    padding: 8px 10px; /* Adjust button padding for easier clickability */
    margin: 4px; /* Reduce margin to fit more content */
  }

  .event-form {
    grid-template-columns: 1fr; /* Adjust form layout to single column for narrow screens */
  }

  input[type="date"], input[type="text"], input[type="number"], select {
    margin: 4px 0; /* Reduce margin around inputs for compact layout */
  }

  .event-form button {
    padding: 8px 10px; /* Adjust button size for mobile */
  }

  table, th, td {
    font-size: 12px; /* Smaller table font size for mobile */
  }
}
  </style>
